import { Reducer } from "redux";
import { call, put, takeLatest } from "redux-saga/effects";
import { TAppActions } from "../rootDuck";

import { getTrial } from "../../crud/trial.crud";
import { IServerResponse } from "../../interfaces/server";
import { ITrial } from "../../interfaces/trial";
import { ActionsUnion, createAction } from "../../utils/action-helper";
import { changeSegmentTitles, getSegmentTitles } from "../../crud/segment.crud";

const CLEAR_FETCH = "trial/CLEAR_FETCH";
const FETCH_REQUEST = "trial/FETCH_REQUEST";
const FETCH_SUCCESS = "trial/FETCH_SUCCESS";
const FETCH_FAIL = "trial/FETCH_FAIL";

const CLEAR_CHANGE_FETCH = "trial/CLEAR_CHANGE_FETCH";
const FETCH_CHANGE_REQUEST = "trial/FETCH_CHANGE_REQUEST";
const FETCH_CHANGE_SUCCESS = "trial/FETCH_CHANGE_SUCCESS";
const FETCH_CHANGE_FAIL = "trial/FETCH_CHANGE_FAIL";

const SET_SELECTED_SEGMENTS = "SET_SELECTED_SEGMENTS";

export interface IInitialState {
  loading: boolean;
  success: boolean;
  error: string | null;
  segmentTitles: Array<any>;
  selectedSegments: any;
}

const initialState: IInitialState = {
  loading: false,
  success: false,
  error: null,
  segmentTitles: [],
  selectedSegments: {
    segment1: "",
    segment2: "",
    segment3: "",
  },
};

export const reducer: Reducer<IInitialState, TAppActions> = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_FETCH: {
      return {
        ...state,
        loading: false,
        success: false,
        error: null,
      };
    }

    case FETCH_REQUEST: {
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };
    }

    case FETCH_SUCCESS: {
      return {
        ...state,
        segmentTitles: action.payload.response.data,
        loading: false,
        success: true,
      };
    }

    case FETCH_FAIL: {
      return { ...state, loading: false, error: action.payload.error };
    }

    case CLEAR_CHANGE_FETCH: {
      return {
        ...state,
        loading: false,
        success: false,
        error: null,
      };
    }
    case FETCH_CHANGE_REQUEST: {
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };
    }

    case FETCH_CHANGE_SUCCESS: {
      return {
        ...state,
        segmentTitles: action.payload.response.data,
        loading: false,
        success: true,
      };
    }

    case FETCH_CHANGE_FAIL: {
      return { ...state, loading: false, error: action.payload.error };
    }

    case SET_SELECTED_SEGMENTS: {
      return {
        ...state,
        selectedSegments: {
          segment1: action.payload.segment1,
          segment2: action.payload.segment2,
          segment3: action.payload.segment3,
        },
      };
    }

    default:
      return state;
  }
};

export const actions = {
  clearFetch: () => createAction(CLEAR_FETCH),
  fetchRequest: () => createAction(FETCH_REQUEST),
  fetchSuccess: (response: any) => createAction(FETCH_SUCCESS, { response }),
  fetchFail: (error: string) => createAction(FETCH_FAIL, { error }),

  clearChangeFetch: () => createAction(CLEAR_CHANGE_FETCH),
  fetchChangeRequest: ({
    payload,
  }: {
    payload: {
      segment1_vendor: string;
      segment2_vendor: string;
      segment3_vendor: string;
      segment1_buyer: string;
      segment2_buyer: string;
      segment3_buyer: string;
    };
  }) => createAction(FETCH_CHANGE_REQUEST, payload),
  fetchChangeSuccess: (response: any) => createAction(FETCH_CHANGE_SUCCESS, { response }),
  fetchChangeFail: (error: string) => createAction(FETCH_CHANGE_FAIL, { error }),

  setSelectedSegments: (payload: { segment1: string; segment2: string; segment3: string }) => createAction(SET_SELECTED_SEGMENTS, payload),
};

export type TActions = ActionsUnion<typeof actions>;

function* fetchSaga() {
  try {
    const { data }: { data: IServerResponse<ITrial> } = yield call(() => getSegmentTitles());
    yield put(actions.fetchSuccess(data));
  } catch (e) {
    yield put(actions.fetchFail(e?.response?.data?.message || "Ошибка соединения."));
  }
}

function* changeSegmentTitlesSaga({
  payload,
}: {
  payload: {
    segment1_vendor: string;
    segment2_vendor: string;
    segment3_vendor: string;
    segment1_buyer: string;
    segment2_buyer: string;
    segment3_buyer: string;
  };
}) {
  try {
    const { data }: { data: IServerResponse<ITrial> } = yield call(() =>
      changeSegmentTitles({
        segment1_vendor: payload.segment1_vendor,
        segment2_vendor: payload.segment2_vendor,
        segment3_vendor: payload.segment3_vendor,
        segment1_buyer: payload.segment1_buyer,
        segment2_buyer: payload.segment2_buyer,
        segment3_buyer: payload.segment3_buyer,
      })
    );
    yield put(actions.fetchChangeSuccess(data));
  } catch (e) {
    yield put(actions.fetchChangeFail(e?.response?.data?.message || "Ошибка соединения."));
  }
}

export function* saga() {
  yield takeLatest<ReturnType<typeof actions.fetchRequest>>(FETCH_REQUEST, fetchSaga);
  yield takeLatest<ReturnType<typeof actions.fetchChangeRequest>>(FETCH_CHANGE_REQUEST, changeSegmentTitlesSaga);
}
